import {
  ActiveTab,
  Assign,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog
} from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";
import urlJoin from "url-join";

const SellerSection = "/seller/";

export const SellerListPath = SellerSection;
export const SellerAddPath = urlJoin(SellerSection, "add");
export const SellerDetailsPath = (id: string) => urlJoin(SellerSection, id);

export const StoreListPath = "/store/";
export const StoreDetailPath = (id: string) => urlJoin(StoreListPath, id);

export enum SellerListUrlFiltersEnum {
  brand = "brand",
  status = "status",
  query = "query"
}
export type SellerListUrlDialog =
  | "add"
  | "view-store"
  | "assign"
  | "removeImage"
  | TabActionDialog;
export enum SellerListUrlSortField {
  name = "name",
  email = "email"
}
export type SellerListUrlSort = Sort<SellerListUrlSortField>;
export type SellerListUrlFilters = Filters<SellerListUrlFiltersEnum>;

export type SellerListUrlQueryParams = ActiveTab &
  SellerListUrlFilters &
  BulkAction &
  Dialog<SellerListUrlDialog> &
  Pagination &
  SingleAction &
  Assign &
  SellerListUrlSort;

export const sellerDetailsUrl = (
  id: string,
  params?: SellerListUrlQueryParams
) => SellerDetailsPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const sellerListUrl = (params?: SellerListUrlQueryParams) =>
  SellerListPath + "?" + stringifyQs(params);

export const sellerSortListUrl = (params?: SellerListUrlQueryParams) =>
  SellerListPath + "?" + stringifyQs(params);
